var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-survey__inner" }, [
    _c(
      "div",
      {
        staticClass:
          "c-survey__content c-survey__content--padding c-survey__content--white-bg",
      },
      [
        _c("main", {
          staticClass: "c-survey__html",
          domProps: { innerHTML: _vm._s(_vm.intro.content) },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "c-survey__actionbutton-row c-survey__actionbutton-row--center",
          },
          [
            _c("ActionButton", {
              attrs: {
                title: _vm.intro.prevLabel,
                buttonAction: "prev",
                arrowUp: true,
                muted: true,
              },
            }),
            _vm._v(" "),
            _c("ActionButton", {
              attrs: {
                title: _vm.intro.nextLabel,
                buttonAction: "next",
                arrowDown: true,
              },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }